import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Class merging for Growth Desk parts. The app's `cn` doesn't know the Growth Desk type scale
 * (text-body, text-small, text-label…), so it would treat `text-small text-ink-2` as two colours
 * and drop one. This merge knows they are font sizes.
 */
const merge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['display-xl', 'display-l', 'display-m', 'section', 'card-title', 'body', 'small', 'label', 'money'] }],
      'font-family': [{ font: ['money'] }],
      rounded: [{ rounded: ['btn', 'card', 'panel'] }],
      shadow: [{ shadow: ['decide', 'ring-line', 'ring-ink'] }],
    },
  },
});

export const cx = (...inputs: ClassValue[]) => merge(clsx(inputs));
